import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	folderId: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	pageSize: 5,
	folderId: null,
};

const portalFiles = createSlice({
	name: 'portalFiles',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setFolderId: (state, action: PayloadAction<{ folderId: string | null }>) => {
			state.folderId = action.payload.folderId;
			state.page = initialState.page;
			state.pageSize = initialState.pageSize;
			state.searchValue = initialState.searchValue;
			state.sortDirection = initialState.sortDirection;
			state.sortFieldName = initialState.sortFieldName;
		},
		resetPortalFiles: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setFolderId,
	resetPortalFiles,
} = portalFiles.actions;

export default portalFiles.reducer;
